var render = function render(){var _vm=this,_c=_vm._self._c;return _c('be-modal',{attrs:{"id":_vm.privacyModal.idModal,"title":_vm.$t('b2c_privacy_policy')}},[_c('div',{staticClass:"be-content",domProps:{"innerHTML":_vm._s(_vm.privacyModal.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }